"use client";

/**
 * DragScrollRow — 가로로 흐르는 줄. 마우스로 끌어서 넘길 수 있다.
 * @description 끌기 규칙은 `useDragScroll` 이 갖는다(`Slider` 와 같은 것). 이 컴포넌트는
 *   클래스를 바깥에서 받아 여백·간격을 호출부가 정하는 얇은 껍데기다 — 축이 정해진
 *   가로줄은 `Slider` 를 쓴다.
 *
 *   스크롤바는 감춘다. 카드가 화면 밖으로 잘려 보이는 것 자체가 "더 있다" 는 신호라
 *   막대가 하나 더 붙으면 시안에 없던 선이 생긴다.
 */
import type { ReactNode } from "react";

import { useDragScroll } from "./useDragScroll";

interface DragScrollRowProps {
  children: ReactNode;
  className?: string;
}

export function DragScrollRow({ children, className }: DragScrollRowProps) {
  const { ref, handlers } = useDragScroll<HTMLDivElement>();

  return (
    <div
      ref={ref}
      {...handlers}
      className={[
        "overflow-x-auto",
        // 스크롤바를 감춘다 — 크롬/사파리와 파이어폭스가 서로 다른 방법을 쓴다.
        "[scrollbar-width:none] [&::-webkit-scrollbar]:hidden",
        // 끄는 동안 카드 안 텍스트나 이미지가 선택되지 않게.
        "cursor-grab select-none active:cursor-grabbing",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      {children}
    </div>
  );
}
